import React from 'react'

import "./About.scss"

function About() {
  return (
    <div className="container block is-max-desktop">
      <div className="container block">
        <h3 className="has-text-weight-bold is-size-3 honey-text-font-family-common honey-text-common">
          About
        </h3>
        <p className="block honey-text-common honey-about-founder">Founded by&nbsp;
          <a href="">Pedro Melgueira</a>.
          &nbsp;
          <a target="_blank" rel="noopener noreferrer" href="mailto:info@honeyshare.live"><i className="fa-solid fa-external-link"></i></a>
        </p>
        <p className="block honey-text-common">Years of Experience: Over 10 years of Software Engineering</p>
        <p className="block honey-text-common">Skills: Leadership and Project Management</p>
        <p className="block honey-text-common">Areas: Cyber Security and FinTech</p>
        <p className="block honey-text-common">Location: Frankfurt, Germany</p>
      </div>
    </div>
  );
}

export default About;
